import { render, staticRenderFns } from "./budgetsCible.vue?vue&type=template&id=0bfdccd4&"
import script from "./budgetsCible.vue?vue&type=script&lang=js&"
export * from "./budgetsCible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports